import Vue from 'vue';
import {
  Message,
  Popover,
  Dialog,
  RadioGroup,
  Radio,
  MessageBox,
  Upload,
  Scrollbar,
  Checkbox
} from 'element-ui';
import 'element-ui/lib/theme-chalk/message.css'
import 'element-ui/lib/theme-chalk/dialog.css'
import 'element-ui/lib/theme-chalk/radio.css'
import 'element-ui/lib/theme-chalk/radio-group.css'
import 'element-ui/lib/theme-chalk/message-box.css'
import 'element-ui/lib/theme-chalk/upload.css'
import 'element-ui/lib/theme-chalk/scrollbar.css'
import 'element-ui/lib/theme-chalk/checkbox.css'

const CustomToast = (options) => {
  options = options || {}
  if (typeof options === 'string') {
    options = {
      message: options
    }
  }
  options.customClass = 'ss__toast'
  options.iconClass = `ssCommunityIcon__${options.type || 'info'}`
  return Message(options)
}
Vue.prototype.$toast = CustomToast
Vue.prototype.$confirm = MessageBox.confirm

Vue.use(Popover)
Vue.use(Dialog)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Upload)
Vue.use(Scrollbar)
Vue.use(Checkbox)

export {
  CustomToast
}
